import HttpService from '@/services/http/http.service';


export default class MachineService {
	constructor() {
		this.http = new HttpService();
	}

	start(machineId) {
		return this.http.patch(`machine/${machineId}/start`)
	}

	stop(machineId) {
		return this.http.patch(`machine/${machineId}/stop`)
	}

	reset(machineId) {
		return this.http.patch(`machine/${machineId}/reset`)
	}

	status(machineId) {
		return this.http.get(`machine/${machineId}/status`)
	}

	ip(machineId) {
		return this.http.get(`machine/${machineId}/ip`)
	}
}
